import { type JSX, memo, type PropsWithChildren } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isFalsy } from "@vega-core/utils/isFalsy";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  className?: string;
  customBackground?: string;
  description?: JSX.Element | string | null;
  descriptionMaxWidth?: string;
  icon?: JSX.Element;
  title?: JSX.Element | string;
  noPanelMarginTop?: boolean;
};

export const Panel = memo(
  ({
    children,
    className,
    customBackground,
    description,
    descriptionMaxWidth,
    icon,
    title,
    noPanelMarginTop = false,
  }: PropsWithChildren<Props>) => (
    <div
      className={cnTwMerge(
        className,
        customBackground,
        "transition-colors flex w-full flex-col items-center rounded-companyBorderRadius",
        {
          "bg-dark-gray": isFalsy(customBackground),
          "px-4 py-8": isTruthy(description),
        },
      )}
      role="dialog"
    >
      {icon}
      <h3 className="body-large-semibold text-text/primary">{title}</h3>
      {isTruthy(description) ? (
        <div
          className={cnTwMerge(
            descriptionMaxWidth,
            "max-w-sm text-center body-base-regular text-text/primary",
            {
              "max-w-sm": isFalsy(descriptionMaxWidth),
            },
          )}
        >
          {description}
        </div>
      ) : null}
      <div className={cnTwMerge("mt-6", { "mt-0": noPanelMarginTop })}>
        {children}
      </div>
    </div>
  ),
);
